module.exports = __webpack_public_path__ + "static/img/房源-4.94c330c7.png";